import { render } from "./IconTournamentVenue.vue?vue&type=template&id=de90ae2e&ts=true"
import script from "./IconTournamentVenue.vue?vue&type=script&lang=ts"
export * from "./IconTournamentVenue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__